import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { LearningStats } from '../types';
import LearningStatsService from '../../../services/LearningStatsService';

// Query keys
export const LEARNING_STATS_QUERY_KEYS = {
  stats: ['learningStats'] as const,
  todayProgress: ['learningStats', 'todayProgress'] as const,
} as const;

// Get learning stats
const getLearningStats = async (): Promise<LearningStats> => {
  return await LearningStatsService.getLearningStats();
};

// Get today's progress
const getTodayProgress = async () => {
  return await LearningStatsService.getTodayProgress();
};

// Update daily goal
const updateDailyGoal = async (newGoal: number): Promise<LearningStats> => {
  return await LearningStatsService.updateDailyGoal(newGoal);
};

// React Query hooks
export const useLearningStats = () => {
  return useQuery({
    queryKey: LEARNING_STATS_QUERY_KEYS.stats,
    queryFn: getLearningStats,
  });
};

export const useTodayProgress = () => {
  return useQuery({
    queryKey: LEARNING_STATS_QUERY_KEYS.todayProgress,
    queryFn: getTodayProgress,
  });
};

export const useUpdateDailyGoal = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: updateDailyGoal,
    onSuccess: () => {
      // Invalidate both stats and today's progress
      queryClient.invalidateQueries({ queryKey: LEARNING_STATS_QUERY_KEYS.stats });
      queryClient.invalidateQueries({ queryKey: LEARNING_STATS_QUERY_KEYS.todayProgress });
    },
  });
}; 